(() => {
const $7a066538416759fa$export$e1252723db1c541 = {
    nav: 'header.nav',
    lvl1Li: 'li.lvl--1',
    lvl1LiMain: 'li.lvl--1.lvl--main',
    mobileNav: 'ul.nav__mobile',
    primaryNavSelector: 'header.nav li.lvl--1.lvl--main',
    stages: 'header.nav li.lvl--1.lvl--main > .sub',
    secondLvlNavItems: 'li.lvl--2.lvl--main',
    thirdLvlNavMenus: 'header.nav ul.lvl--3.lvl--main',
    mobileNavSelector: 'header.nav li.lvl--1.lvl--mobile ul.nav__mobile li.lvl--1',
    search: 'header.nav li.lvl--search .site-search__form'
};
const $7a066538416759fa$export$d8c10dd8041b9a03 = (id)=>`ul.lvl--3[data-parent=${id}]`;
const $7a066538416759fa$export$7a5d735b2ab6389d = {
    html: document.querySelector('html'),
    body: document.querySelector('body'),
    nav: document.querySelector('header.nav')
};
const $7a066538416759fa$export$ce4ab0c55987d1ff = {
    bg: 'nav--bg',
    lvl1: 'lvl--1',
    lvlFocus: 'lvl--focus',
    lvlOpen: 'lvl--open',
    lvlSubmenu: 'lvl--submenu',
    mobileDevice: 'is-mobile',
    mobileOpen: 'menu-open',
    mobileSelect: 'nav__mobile--selected',
    stageOpen: 'mega-menu-stage-open'
};


const $d0dda76d04890641$var$setHighlightColorScheme = ()=>{
    (0, $7a066538416759fa$export$7a5d735b2ab6389d).nav.setAttribute('data-color-scheme', 'highlight');
};
const $d0dda76d04890641$var$removeHighlightColorScheme = ()=>{
    (0, $7a066538416759fa$export$7a5d735b2ab6389d).nav.hasAttribute('data-color-scheme') && (0, $7a066538416759fa$export$7a5d735b2ab6389d).nav.removeAttribute('data-color-scheme');
};
const $d0dda76d04890641$export$eb2271675e8a05de = ()=>{
    const navOnHighlightBG = (0, $7a066538416759fa$export$7a5d735b2ab6389d).nav.classList.contains('nav--on-highlight');
    const desktopNav = !document.body.classList.contains((0, $7a066538416759fa$export$ce4ab0c55987d1ff).mobileDevice) && window.innerWidth > 1200;
    const notScrolled = window.scrollY === 0;
    const noOpenStage = !document.body.classList.contains((0, $7a066538416759fa$export$ce4ab0c55987d1ff).stageOpen);
    $d0dda76d04890641$var$removeHighlightColorScheme();
    navOnHighlightBG && desktopNav && notScrolled && noOpenStage && $d0dda76d04890641$var$setHighlightColorScheme();
};


const $bc13a119e84f7c86$export$b0075d360ec51338 = (listItem)=>{
    const stageVisual = listItem.querySelector('.sub--stage .sub__visual');
    if (stageVisual) {
        const visualUrl = stageVisual.getAttribute('data-image-url');
        if (!stageVisual.style.background && visualUrl) {
            stageVisual.style.backgroundImage = `url(${visualUrl})`;
            stageVisual.removeAttribute('data-image-url');
        }
    }
};





const $879feefeab0eff57$var$scrollCallback = ()=>{
    // Adds a class to differ between nav and background
    if (window.scrollY > 0) (0, $7a066538416759fa$export$7a5d735b2ab6389d).nav.classList.add((0, $7a066538416759fa$export$ce4ab0c55987d1ff).bg);
    else if (!(0, $7a066538416759fa$export$7a5d735b2ab6389d).body.classList.contains((0, $7a066538416759fa$export$ce4ab0c55987d1ff).stageOpen)) (0, $7a066538416759fa$export$7a5d735b2ab6389d).nav.classList.remove((0, $7a066538416759fa$export$ce4ab0c55987d1ff).bg);
    (0, $d0dda76d04890641$export$eb2271675e8a05de)();
};
const $879feefeab0eff57$export$69635ce252902aa6 = ()=>{
    [
        'scroll',
        'DOMContentLoaded',
        'resize'
    ].forEach((type)=>{
        window.addEventListener(type, ()=>{
            $879feefeab0eff57$var$scrollCallback();
        });
    });
};


// Set the search in the main navigation to highlight.
const $ea1e6a0afe0bf652$var$search = document.querySelector((0, $7a066538416759fa$export$e1252723db1c541).search);
$ea1e6a0afe0bf652$var$search && $ea1e6a0afe0bf652$var$search.setAttribute('data-color-scheme', 'highlight');
const $ea1e6a0afe0bf652$var$mobileOpenClass = (set = true)=>{
    set ? (0, $7a066538416759fa$export$7a5d735b2ab6389d).html.classList.add((0, $7a066538416759fa$export$ce4ab0c55987d1ff).mobileOpen) : (0, $7a066538416759fa$export$7a5d735b2ab6389d).html.classList.remove((0, $7a066538416759fa$export$ce4ab0c55987d1ff).mobileOpen);
};
const $ea1e6a0afe0bf652$var$handleNavClick = (element, selector, closestItem, clickOutsideListener = false)=>{
    element.addEventListener('click', ()=>{
        const mobileCtr = document.querySelector((0, $7a066538416759fa$export$e1252723db1c541).mobileNavSelector).closest((0, $7a066538416759fa$export$e1252723db1c541).mobileNav);
        const clickOnBurger = element.classList.contains('menu');
        // Get the surrounding list element element
        const listItemCtr = element.closest(closestItem);
        if (listItemCtr.classList.contains((0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlOpen)) {
            // ! Click on a opened menu item.
            $ea1e6a0afe0bf652$var$mobileOpenClass(false);
            listItemCtr.classList.remove((0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlOpen);
            if (!clickOutsideListener) // The inner mobile navigation has no list, so the click must be directed to the mobile navigation.
            // Since this click is on an open element, the indicator must be removed.
            mobileCtr.classList.remove((0, $7a066538416759fa$export$ce4ab0c55987d1ff).mobileSelect);
        } else {
            // ! Click on a menu item that is closed.
            $ea1e6a0afe0bf652$var$mobileOpenClass(clickOnBurger);
            // Close other open menu item that needs to be closed first
            document.querySelector(`${selector}.${(0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlOpen}`)?.classList.remove((0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlOpen);
            // Set the list element to active.
            listItemCtr.classList.add((0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlOpen);
            // Load the stage background if stage available.
            (0, $bc13a119e84f7c86$export$b0075d360ec51338)(listItemCtr);
            // Add event listener to watch for clicks outside of the current active list item.
            if (clickOutsideListener) window.addEventListener('click', $ea1e6a0afe0bf652$var$checkForNavOutsideClicks);
            else // The inner mobile navigation has no list, so the click must be directed to the mobile navigation.
            // Since this click is on a closed element, the indicator must be added.
            mobileCtr.classList.add((0, $7a066538416759fa$export$ce4ab0c55987d1ff).mobileSelect);
        }
        // Set body class
        if (!clickOnBurger) {
            const itemClasses = listItemCtr.classList;
            const bodyClasses = (0, $7a066538416759fa$export$7a5d735b2ab6389d).body.classList;
            if (itemClasses.contains((0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvl1) && itemClasses.contains((0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlOpen)) {
                bodyClasses.add((0, $7a066538416759fa$export$ce4ab0c55987d1ff).stageOpen);
                (0, $7a066538416759fa$export$7a5d735b2ab6389d).nav.classList.add((0, $7a066538416759fa$export$ce4ab0c55987d1ff).bg);
            } else {
                bodyClasses.remove((0, $7a066538416759fa$export$ce4ab0c55987d1ff).stageOpen);
                if (window.scrollY === 0) (0, $7a066538416759fa$export$7a5d735b2ab6389d).nav.classList.remove((0, $7a066538416759fa$export$ce4ab0c55987d1ff).bg);
            }
            (0, $d0dda76d04890641$export$eb2271675e8a05de)();
        }
    });
};
const $ea1e6a0afe0bf652$var$closeStage = ()=>{
    // Check if user clicks outside of the active menu item to close it again
    document.querySelector(`${(0, $7a066538416759fa$export$e1252723db1c541).primaryNavSelector}.${(0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlOpen}`)?.classList.remove((0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlOpen);
    // Remove body class
    (0, $7a066538416759fa$export$7a5d735b2ab6389d).body.classList.remove((0, $7a066538416759fa$export$ce4ab0c55987d1ff).stageOpen);
    (0, $d0dda76d04890641$export$eb2271675e8a05de)();
    window.removeEventListener('click', $ea1e6a0afe0bf652$var$checkForNavOutsideClicks);
};
const $ea1e6a0afe0bf652$var$checkForNavOutsideClicks = (e)=>{
    if (!e.target.closest((0, $7a066538416759fa$export$e1252723db1c541).lvl1LiMain)?.classList.contains((0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlOpen)) {
        $ea1e6a0afe0bf652$var$closeStage();
        if (window.scrollY === 0) (0, $7a066538416759fa$export$7a5d735b2ab6389d).nav.classList.remove((0, $7a066538416759fa$export$ce4ab0c55987d1ff).bg);
    }
};
// Handle click for primary level nav items
document.querySelectorAll(`${(0, $7a066538416759fa$export$e1252723db1c541).primaryNavSelector}.${(0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlSubmenu} > a`).forEach((el)=>{
    $ea1e6a0afe0bf652$var$handleNavClick(el, (0, $7a066538416759fa$export$e1252723db1c541).primaryNavSelector, (0, $7a066538416759fa$export$e1252723db1c541).lvl1Li, true);
});
const $ea1e6a0afe0bf652$var$openThirdLvlMenu = (el)=>{
    const id = el.id;
    el.classList.add((0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlFocus);
    const targetMenu = el.closest((0, $7a066538416759fa$export$e1252723db1c541).lvl1Li).querySelector((0, $7a066538416759fa$export$d8c10dd8041b9a03)(id));
    targetMenu && targetMenu.classList.add((0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlOpen);
};
const $ea1e6a0afe0bf652$var$setSubNavOffset = ()=>{
    if ((0, $7a066538416759fa$export$7a5d735b2ab6389d).nav) {
        const headerNavRect = (0, $7a066538416759fa$export$7a5d735b2ab6389d).nav.getBoundingClientRect();
        (0, $7a066538416759fa$export$7a5d735b2ab6389d).nav.style.setProperty('--subnav-offset', `${headerNavRect.top + headerNavRect.height}px`);
    }
};
// Update subnav offset when
// 1. window is scrolled
// 2. the body dimensions changed
(()=>{
    $ea1e6a0afe0bf652$var$setSubNavOffset();
    window.addEventListener('scroll', ()=>{
        $ea1e6a0afe0bf652$var$setSubNavOffset();
    });
    const resizeObserver = new ResizeObserver($ea1e6a0afe0bf652$var$setSubNavOffset);
    resizeObserver.observe(document.body);
})();
// Handle 2nd level nav items in desktop mega menu.
document.querySelectorAll((0, $7a066538416759fa$export$e1252723db1c541).stages).forEach((stage)=>{
    const secondLvlNavAncestor = stage.querySelectorAll(`${(0, $7a066538416759fa$export$e1252723db1c541).secondLvlNavItems} a.current-menu-ancestor`);
    const secondLvlNavItems = stage.querySelectorAll(`${(0, $7a066538416759fa$export$e1252723db1c541).secondLvlNavItems} > a.menu-item-has-children`);
    const addSecondLvlNavLinkListener = (link)=>{
        // Add click event listener.
        link.addEventListener('click', ()=>{
            if (!link.classList.contains((0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlFocus)) {
                // Remove focus class from 2nd level nav items.
                secondLvlNavItems.forEach((el)=>el.classList.remove((0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlFocus));
                // Close all 3rd level nav menus.
                stage.querySelectorAll((0, $7a066538416759fa$export$e1252723db1c541).thirdLvlNavMenus).forEach((menu)=>menu.classList.remove((0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlOpen));
                setTimeout(()=>{
                    $ea1e6a0afe0bf652$var$openThirdLvlMenu(link);
                }, 250);
            }
        });
    };
    if (secondLvlNavAncestor.length) // Activate the second level navigation point which third level navigation point is active.
    $ea1e6a0afe0bf652$var$openThirdLvlMenu(secondLvlNavAncestor[0]);
    else if (secondLvlNavItems.length) // Activate first 2nd lvl nav item and related 3rd level nav menu.
    $ea1e6a0afe0bf652$var$openThirdLvlMenu(secondLvlNavItems[0]);
    // Close stage after click on an anchor link.
    stage.querySelectorAll('a[href*="#"]').forEach((el)=>{
        el.addEventListener('click', $ea1e6a0afe0bf652$var$closeStage);
    });
    secondLvlNavItems.forEach((link)=>{
        addSecondLvlNavLinkListener(link);
    });
});
// Handle click for 2nd level mobile nav items.
document.querySelectorAll(`${(0, $7a066538416759fa$export$e1252723db1c541).mobileNavSelector}.${(0, $7a066538416759fa$export$ce4ab0c55987d1ff).lvlSubmenu} > a`).forEach((el)=>{
    $ea1e6a0afe0bf652$var$handleNavClick(el, (0, $7a066538416759fa$export$e1252723db1c541).mobileNavSelector, (0, $7a066538416759fa$export$e1252723db1c541).lvl1Li);
});
(0, $7a066538416759fa$export$7a5d735b2ab6389d).nav && (0, $879feefeab0eff57$export$69635ce252902aa6)();

})();
//# sourceMappingURL=navigation.min.js.map
